const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Crée le tien",
  description: "",
  difficulty: "ALL",
  learnLang: "french",
};

export default authorFromScratch;
